// Enums here


enum Roles {
    ADMIN = "admin",
    OPREPORTING = "op_reporting",
    SEGMENT = "segments",
    TAGGER = "tagger",
    SPECIAL = "special",
    TESTER = 'tester',
    // JS_CONFIG = 'jsconfig',
    CAMP = 'campaigns',
    CTARGET = 'ctarget',
    PROD_FILTERING='prod_filtering',
    DEMO_FILTERING='demo_filtering',
    CLOGGER='clogger',
    AIMP='ads_imp',
    // GLU='glu',
    OP_CREATIVE_UPLOAD = 'op_creative',
    HTML5_GENERATOR='html5_gen',
    BID_REQUESTS ='bid_requests',
    REALTIME_MONITOR ='realtime_monitor',
    SUPER_USER = 'SuperUser',
    CREATIVE_UPLOAD = 'creative',
    USER_INFO = 'user_sync_info_1',
    USER_INFO_V2 = 'user_api_info_2',
    USER_INFO_NG = 'userinfo',
    ADSD = 'ads_dashboard',
    YANDEX = 'yandex'
    
}

export { Roles };
